export default __webpack_public_path__ + "static/media/232.62a44fc8.png";